import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
// components
import Application from './ProspectForm';

export default class PublicProspect extends Component {
  static propTypes = {
    children: PropTypes.any
  };

  render() {

    return (
      <div className='prospect-application'>
        <div className='header'>
          <span data-id='Title Text'>
            Contact Us
          </span>
          <span className='login' data-id='Login Text'>
            Returning client? Please&nbsp;
            <Link to='/login' className='link login-link' data-id='Login Link'>
              sign in
            </Link>
          </span>
        </div>
        <Application />
        {
          this.props.children
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/public/PublicProspect.js